<template>
  <div id="profile">
    <v-row>
      <v-col cols="3" sm="3" style="padding: 0 12px">
        <div class="sidebar">
          <v-card height="600" width="256px">
            <v-navigation-drawer permanent>
              <v-list-item class="d-none d-sm-block">
                <v-list-item-content>
                  <EditDeleteProfileImage
                    :general="general"
                  ></EditDeleteProfileImage>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list dense nav>
                <div v-for="item in items" :key="item.title">
                  <v-list-item
                    :class="item.active == true ? 'active' : ''"
                    link
                    @click="sidebarItemclick(item.id)"
                  >
                    <v-list-item-icon>
                      <v-icon :title="item.title">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>
            </v-navigation-drawer>
          </v-card>
        </div>
      </v-col>
      <v-col cols="9" sm="9" v-if="selectedTab == 1">
        <studentGeneralInfo
          :general="general"
          :general_edit="general_edit"
          :dataObject="dataObject"
          :openEdit="openEdit"
          v-on:updated="dataUpdated"
          v-if="Object.keys(general).length > 0"
        ></studentGeneralInfo>
      </v-col>
      <v-col cols="9" sm="9" v-if="selectedTab == 2">
        <studentTeachingAndCurriculum
          :info="info"
          :info_edit="info_edit"
          v-on:updated="dataUpdated"
          v-on:updateData="getDataFromApi"
        ></studentTeachingAndCurriculum>
      </v-col>
      <v-col cols="9" sm="9" v-if="selectedTab == 3">
        <studentPayment
          :dataObject="dataObject"
          :payment="payment"
          v-on:updated="dataUpdated"
        ></studentPayment>
      </v-col>

      <v-col cols="9" sm="9" v-if="selectedTab == 4">
        <studentLoginSetting
          :login="login"
          v-on:updated="dataUpdated"
        ></studentLoginSetting>
      </v-col>
    </v-row>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";
import studentGeneralInfo from "../../components/studentGeneralInfo";
import studentTeachingAndCurriculum from "../../components/studentTeachingAndCurriculum";
import studentPayment from "../../components/studentPayment";
import studentLoginSetting from "../../components/studentLoginSetting";
import EditDeleteProfileImage from "../../components/EditDeleteProfileImage";

export default {
  name: "studentProfileShow",
  mixins: [validationMixin],
  components: {
    studentGeneralInfo,
    studentTeachingAndCurriculum,
    studentPayment,
    studentLoginSetting,
    EditDeleteProfileImage
  },
  data() {
    return {
      componentKey: true,
      items: [
        {
          id: "1",
          title: this.$i18n.t("generalInfo"),
          icon: "info",
          active: true
        },
        {
          id: "2",
          title: this.$i18n.t("Teaching and Curriculum"),
          icon: "work",
          active: false
        },
        {
          id: "3",
          title: this.$i18n.t("Payment Information"),
          icon: "attach_money",
          active: false
        },
        // { id: "4", title: "افضاليات", icon: "settings", active: false },
        {
          id: "4",
          title: this.$i18n.t("Registration Info"),
          icon: "lock",
          active: false
        }
      ],
      right: null,
      valid: false,
      selectedTab: 1,
      general: {},
      info: {},
      payment: {},
      login: {},
      general_edit: {},
      info_edit: {},
      openEdit: false,
      dataObject: {
        nationalities: [],
        curriculums: [],
        languages: [],
        Codes: []
      }
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.tab !== undefined) {
          this.sidebarItemclick(Number(this.$route.query.tab));
          console.log(this.$route.query.tab);
        }
      }
    },
    selectedTab: {
      handler() {
        this.selectedTab != 1 ? (this.openEdit = false) : "";

        this.$router.push({
          path: "/student/profilesettings?tab=" + this.selectedTab
        });
      }
    }
  },
  methods: {
    sidebarItemclick(id) {
      this.items.forEach(item => {
        item.active = false;
        if (item.id == id) {
          item.active = true;
          this.selectedTab = item.id;
        }
      });
    },
    dataUpdated(error, message) {
      if (error) {
        this.$refs.snack.sendErrorAlert(message);
      } else {
        this.$refs.snack.sendSuccessAlert(message);
        this.getDataFromApi();
      }
    },
    getDataFromApi() {
      this.$http
        .get(this.getApiUrl + "/student/profileData", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            console.log(response.data.data);
            this.general = response.data.data.general;
            this.info = response.data.data.info;
            this.login = response.data.data.login;
            this.general_edit = response.data.data.general_edit;
            this.info_edit = response.data.data.info_edit;
            this.payment = response.data.data.payment;
          }
        });
    },

    getDataForTeacherRegistration() {
      this.$http
        .get(this.getApiUrl + "/getDataForTeacherRegistration")
        .then(response => {
          // console.log(response.data.data);
          this.dataObject.nationalities = response.data.data.nationalities;
          this.dataObject.curriculums = response.data.data.curricula;
          this.dataObject.languages = response.data.data.languages;
          this.dataObject.Codes = response.data.data.country_codes;
          // this.teacherRegistration.endorsements =
          //   response.data.data.endorsements;
        });
    }
  },
  mounted() {
    if (this.$route.query.tab !== undefined) {
      this.sidebarItemclick(Number(this.$route.query.tab));
      console.log(this.$route.query.tab);
    }

    this.getDataFromApi();
    this.getDataForTeacherRegistration();

    if (this.$route.query.edit == "true") {
      this.openEdit = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

#profile {
  background-color: #fafafa;
  .sidebar {
    .active {
      color: $main-color !important;
      .v-icon {
        color: $main-color;
      }
      .v-list-item__title {
        font-weight: bold !important;
      }
    }
  }
}
.v-btn--icon.v-size--default {
  height: 20px !important;
  width: 20px !important;
}
</style>
